type Branch = 'prod' | 'dev' | 'test' | 'demo';

const BRANCH = (process.env.REACT_APP_BRANCH_NAME || 'prod').toLowerCase() as Branch;

const BASES: Record<Branch, string> = {
  prod: 'https://journey.trackgood.io',
  dev: 'https://journey-dev.trackgood.io',
  test: 'https://journey-test.trackgood.io',
  demo: 'https://journey-demo.trackgood.io',
};

const API_BASES = {
  prod: 'https://journey-api.trackgood.io/v2',
  dev: 'https://journey-api-dev.trackgood.io/v2',
  test: 'https://journey-api-test.trackgood.io/v2',
  demo: 'https://journey-api-demo.trackgood.io/v2',
};

/** Returns env-appropriate site origin (no trailing slash). */
export function getBaseUrl(): string {
  return BASES[BRANCH] || BASES.prod;
}

export function getApiBaseUrl() { return API_BASES[BRANCH] || API_BASES.prod; }

/** Ensures a trailing slash for canonical home. */
export function withTrailingSlash(u: string): string {
  return u.endsWith('/') ? u : `${u}/`;
}

/** Make an absolute URL from possibly-relative `u` using the env base. */
export function toAbs(u?: string): string {
  try { return u ? new URL(u, getBaseUrl()).href : ''; }
  catch { return u || ''; }
}
